import React from 'react';
import { Col } from 'antd';

const getLogoSource = logo => {
  if (!logo) {
    return null;
  }

  // 后端默认返回 Logo 的 Base64 内容；同时兼容特殊头部直接配置图片路径。
  return logo.startsWith('data:') || logo.startsWith('/') || logo.startsWith('http')
    ? logo
    : `data:image/png;base64,${logo}`;
};

const DefaultPaymentHeader = ({ company, branding = {} }) => {
  const companyInfo = company || {};
  const displayInfo = {
    Logo: branding.Logo || companyInfo.Logo,
    Name: branding.Name || companyInfo.Name,
    Website: branding.Website || companyInfo.Website,
    Phone: branding.Phone || companyInfo.Phone,
    ContactEmail: branding.ContactEmail || companyInfo.ContactEmail,
    Abn: branding.Abn || companyInfo.Abn,
  };
  const logoSource = getLogoSource(displayInfo.Logo);

  return (
    <>
      <Col span={12}>
        {logoSource ? <img id="logo" alt={`${displayInfo.Name || 'Company'} logo`} src={logoSource} /> : null}
      </Col>
      <Col span={12} style={{ textAlign: 'right' }}>
        {displayInfo.Name ? <div>{displayInfo.Name}</div> : null}
        {displayInfo.Website ? <div>{displayInfo.Website}</div> : null}
        {displayInfo.Phone ? <div>{displayInfo.Phone}</div> : null}
        {displayInfo.ContactEmail ? <div>{displayInfo.ContactEmail}</div> : null}
        {displayInfo.Abn ? <div>ABN: {displayInfo.Abn}</div> : null}
      </Col>
    </>
  );
};

export default DefaultPaymentHeader;
